exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UserGoalsPage-6baea3e3{clear:both;margin-bottom:150px}.UserGoalsPage-6baea3e3 .setGoalHeading-b21e27bf{text-align:center;margin:0 0 35px 0}.UserGoalsPage-6baea3e3 .yourGoals-614335d8{margin-top:50px}.UserGoalsPage-6baea3e3 .goalsList-3c160be9{margin-bottom:60px}.UserGoalsPage-6baea3e3 .loadingSpinner-73753262{margin-top:30vh}\n", ""]);

// Exports
exports.locals = {
	"UserGoalsPage": "UserGoalsPage-6baea3e3",
	"setGoalHeading": "setGoalHeading-b21e27bf",
	"yourGoals": "yourGoals-614335d8",
	"goalsList": "goalsList-3c160be9",
	"loadingSpinner": "loadingSpinner-73753262"
};